import { apiClient } from '../Auth/apiClient';
import IResponseBaseDto from '../Interfaces/IResponseBaseDto';
import IGoalDetailsDto from '../Interfaces/IGoalDtos';
import ISearchBaseDto from '../Interfaces/ISearchBaseDto';
import IResponseBaseTDto from '../Interfaces/IResponseBaseTDto';
import IPageResultDto from '../Interfaces/IPageResultDto';

const GoalServiceAPI = {
	GetPage: async (data: ISearchBaseDto): Promise<IResponseBaseTDto<IPageResultDto<any>>> => {
		const response = await apiClient.post(`goals`, data);
		return response.data;
	},
	GetOne: async (id: string): Promise<IGoalDetailsDto> => {
		const response = await apiClient.post(`goal`, { id });
		return response.data;
	},
	Update: async (data: IGoalDetailsDto): Promise<IResponseBaseDto> => {
		const response = await apiClient.post(`goal/edit`, data);
		return response.data;
	},
	Delete: async (id: number): Promise<number> => {
		const response = await apiClient.post(`goal/delete`, { id });
		return response.data;
	},
	Add: async (data: IGoalDetailsDto): Promise<IResponseBaseDto> => {
		const response = await apiClient.post(`goal/edit`, { ...data, id: 0 });
		return response.data;
	},
};

export default GoalServiceAPI;
